/**
 * English - `tipsAfterSale`: the ⓘ explanations beside the returns policy,
 * the cancel and request dialogs and a product's return rules. One key per
 * field, `<form>.<field>`, passed as the field's `info`.
 * Conventions: see `common.ts`.
 */
const tipsAfterSale: Record<string, string> = {
  // >>> returns policy
  'policy.customer_cancellation':
    'When on, customers see a Cancel button on their order page and cancel without contacting you. They must pick a reason. When off, they have to message you.',
  'policy.cancellable_statuses':
    'How far along an order can be and still be cancelled by the customer. Past Packed, the parcel is with the courier and it becomes a return instead.',
  'policy.partial_cancellation':
    'Lets a customer cancel some items of an order that has not shipped - for example 1 of 3 kurtas. It is a request: nothing changes until you approve it.',
  'policy.cancellation_reasons':
    'The choices customers pick from when cancelling. "Other" is always added at the end and asks them to type a reason. Up to 20 reasons. Example: Found a better price',
  'policy.returns':
    'Customers can ask to send an item back for a refund, within the days you set. You approve it, then complete it when the parcel arrives.',
  'policy.refunds':
    'Customers can ask for money back while keeping the item - useful for a damaged item that is not worth shipping back. You decide each one.',
  'policy.replacements':
    'Customers can ask for a new unit of the same item. When you complete it, the new unit comes off your stock and no money moves.',
  'policy.window':
    'How many days after delivery customers can still ask. Between 1 and 365. A product can have its own number. Example: 7',
  'policy.allow_photos':
    'When on, customers can attach up to 5 photos to a return, refund or replacement request, so you can see the damage before deciding.',
  'policy.return_reasons':
    'The choices customers pick from for a return, refund or replacement. "Other" is always added at the end. Up to 20 reasons. Example: Wrong size delivered',
  'policy.policy_note':
    'A short note shown on the request form, such as your conditions for taking items back. Optional, up to 1000 characters. Example: Items must be unused with tags',
  'policy.refund_method':
    'How money goes back when a return, refund or partial cancellation is completed. Original payment uses Razorpay for online orders; cash orders are marked for you to pay back.',
  'policy.auto_approve':
    'When on, every customer request is approved the moment it is made. You still complete each one after the parcel comes back or the refund is due.',
  'policy.new_reason':
    'Type a reason customers can pick, then press Add. Up to 120 characters. Example: Delivery is taking too long',

  // >>> cancelling an order
  'cancel.reason':
    'Why you are cancelling. The customer is emailed this and sees it on their order page, so write it for them.',
  'cancel.details':
    'Extra words for the customer, added after the reason. Required when the reason is "Something else". Up to 300 characters. Example: We will restock next week',

  // >>> deciding a request
  'decision.refund_amount':
    'The amount in ₹ sent back to the customer. It starts at these items’ share of what was paid, without delivery charges. Lower it to deduct a fee. Example: 499',
  'decision.note':
    'A message the customer sees on their order page and in the email about this request. Required when rejecting. Up to 500 characters.',

  // >>> a product's return rules
  'product.custom':
    'Off: the product follows your store’s returns policy. On: set this product’s own rules, such as non-returnable for innerwear or perishables.',
  'product.returnable':
    'Customers can send this product back for a refund. Only works if returns are on in your store policy.',
  'product.refundable':
    'Customers can get money back while keeping this product. Only works if refunds are on in your store policy.',
  'product.replaceable':
    'Customers can ask for a new unit of this product. Only works if replacements are on in your store policy.',
  'product.window':
    'Days after delivery customers can ask about this product. Leave empty to use your store’s number. Between 1 and 365. Example: 15',

  // >>> QA phase 5 additions
  'policy.cancellable_status':
    'Ticked, shoppers can cancel an order themselves while it is {status}.',
};

export default tipsAfterSale;
